module.exports = __webpack_public_path__ + "img/bodyImg.66ac2b8b.png";